import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalSettingsService } from './services/local-settings.service';
import { AuthGuardService } from './services/authGuard';
import { Router, NavigationEnd } from '@angular/router';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(translate: TranslateService,LocalSettings:LocalSettingsService,private authService: AuthGuardService,private router: Router) {
    let lang = LocalSettings.getLanguage();
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(lang);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(lang); 
    console.log("LOGIN!!");

  }

  ngOnInit(): void {
    // this.checkIfLogin()
   //this.authService.ImLogged(undefined, undefined)
    this.isUserloggedIn = this.authService.isLoggedIn();
  }


  isUserloggedIn:boolean = false;
  public profile:any=null;

  checkIfLogin=() =>{
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        /* Evolutive Maggio Giugno Luglio 2021: Cliccando sul link della notifica si arriva al direttamente al dettaglio del documento. */
        let id = "";
        if (event != null && event != undefined && event.url != null && event.url != undefined && event.url != "") {
          let d = event.url.split('/');
          if (d != undefined && d != null && d.length > 0) {
            id = d[d.length - 1];
          }
        }
        if(this.authService.isLoggedIn()){
          this.isUserloggedIn = true;
          this.profile=this.authService.getProfile();                                 
        }
        else if (event.url !== '/openIdLogin' && event.url !== '/openIdLogin/'+id) { 
          const m = undefined;
            this.authService.ImLogged(m, undefined).then(
              (result)=>{
                 if(result)
                 {
                    this.isUserloggedIn = this.authService.isLoggedIn(); 
                    this.profile=this.authService.getProfile();
                 }       
              }
            );          
        }            
      }
    });
  }
  title = 'app';
}
